import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { QueryNormalizationCache } from '../query-cache';
import type { PSMEvent } from '../types';

export function useProcessPSMEvent() {
  const client = useQueryClient();
  const cache = client.getQueryCache();

  return useCallback(
    <TState = any, TKeys extends Record<string, string> = any, TEvent = any>(psmEvent: PSMEvent<TState, TKeys, TEvent>) => {
      if (!(cache instanceof QueryNormalizationCache)) {
        console.warn('useProcessPSMEvent should only be used with a NormalizedCache instance');
        return;
      }

      cache.entityCache.processPSMEvent<TState, TKeys, TEvent>(psmEvent, cache);
    },
    [cache],
  );
}
